import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { IntroducersService } from 'src/app/services/api/introducers.service';
import { RouteService } from 'src/app/services/route.service';
import { CommonService } from 'src/app/services/common.service';
import { MainLayoutService } from 'src/app/services/main-layout.service';
import { AccessControlService } from 'src/app/services/access-control.service';

@Component({
  selector: 'app-introducer-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './introducer-detail-page.component.html',
  styleUrl: './introducer-detail-page.component.scss',
})
export class IntroducerDetailPageComponent implements OnInit, OnDestroy {
  baseDetailPageConfig!: BaseDetailPageConfig;
  introducer?: any;
  private subscriptions = new Subscription();

  constructor(
    private introducersService: IntroducersService,
    private routeService: RouteService,
    private commonService: CommonService,
    private mainLayoutService: MainLayoutService,
    private accessControlService: AccessControlService,
  ) {}

  ngOnInit(): void {
    this.baseDetailPageConfig = {
      pageTitle: 'Introducers',
      cardTitle: 'Details',
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => item.name,
          },
          {
            attribute: 'address',
            label: 'Address',
            value: (item: any) => item.address,
          },
          {
            attribute: 'zipCode',
            label: 'Zip Code',
            value: (item: any) => item.zipCode,
          },
          {
            attribute: 'city',
            label: 'City',
            value: (item: any) => item.city,
          },
          {
            attribute: 'vat',
            label: 'Vat',
            value: (item: any) => item.vat,
          },
          {
            attribute: 'contractStartTime',
            label: 'Contract Start Time',
            value: (item: any) => item.contractStartTime ? this.commonService.formatDate(new Date(item.contractStartTime)) : '',
          },
        ],
      },
      apiDetailService: (introducerId: number) =>
        this.introducersService.detail(introducerId),
      routeParamName: 'introducerId',
      responseModelName: 'introducer',
    };

    this.subscriptions.add(
      this.mainLayoutService.activeProfile$.subscribe(profileCode => {
        const canEdit = this.accessControlService.hasFeatureActionAccess(profileCode, 'INTRODUCER_LIST', 'modify');
        this.baseDetailPageConfig.editItemButton = canEdit
          ? {
              type: 'success',
              title: 'Edit Introducer',
              onClick: () => {
                this.routeService.introducerUpdate(this.introducer.introducerId);
              },
            }
          : undefined;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onLoadedDetail(data: any): void {
    this.introducer = data;
  }
}
